// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-time-font {
  font-size: 9px !important;
}

.date-calender {
  border-radius: 19px !important;
  position: absolute !important;
  top: 130% !important;
  left: -20%;
  background: #333333 !important;
  z-index: 1 !important;
}

@media only screen and (max-width: 793px) {
  .date-input {
    width: 100% !important;
  }
  .inputRounded {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/food/common/header/components/date-and-time/date-and-time.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,8BAAA;EACA,6BAAA;EACA,oBAAA;EACA,UAAA;EACA,8BAAA;EAEA,qBAAA;AAAF;;AAIA;EACE;IACE,sBAAA;EADF;EAGA;IACE,sBAAA;EADF;AACF","sourcesContent":[".select-time-font {\n  font-size: 9px !important;\n}\n\n.date-calender {\n  border-radius: 19px !important;\n  position: absolute !important;\n  top: 130% !important;\n  left: -20%;\n  background: #333333 !important;\n  // padding: 10px !important;\n  z-index: 1 !important;\n  // transform: translate(-50%, 0);\n}\n\n@media only screen and (max-width: 793px) {\n  .date-input{\n    width: 100% !important;\n  }\n  .inputRounded{\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
